import { Injectable, signal, computed, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LokaliseService {
  private readonly translocoService = inject(TranslocoService);
  private availableLanguage = ['en', 'es'];
  private currentLanguageSignal = signal('en');
  currentLanguage = this.currentLanguageSignal.asReadonly();

  // Signal to indicate when translations are loaded
  private translationsLoadedSignal = signal(false);
  translationsLoaded = this.translationsLoadedSignal.asReadonly();

  loadTranslations(basePaths: string[]) {
    const loads = basePaths.flatMap(basePath =>
      this.availableLanguage.map(lang =>
        this.translocoService.load(`${basePath}/${lang}`)
      )
    );
    forkJoin(loads).subscribe(() => {
      this.translocoService.setActiveLang(this.currentLanguageSignal());
      console.log(this.translocoService);
      this.translationsLoadedSignal.set(true);
    });
  }

  setCurrentLanguage(lang: string) {
    this.currentLanguageSignal.set(lang);
    this.translocoService.setActiveLang(lang);
  }
}